import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

import arrow from "../assets/kangaroo/whitearrow.png";
import australia from "../assets/kangaroo/Home_Country_Australia.jpg";
import newZealand from "../assets/kangaroo/Home_Country_New Zealand.jpg";
import usa from "../assets/kangaroo/Home_Country_USA.jpg";
import uk from "../assets/kangaroo/Home_Country_UK.jpg";
import canada from "../assets/kangaroo/Home_Country_Canada.jpg";
import { useNavigate } from "react-router-dom";
import Form from "../component/Form/Form";
import Destinationcountry from "../services/Destinationcountry";
import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../services/imageBaseApi";

const Explore = () => {
  const router = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
   const fetchCountryData = async () => {
    const response = await Destinationcountry.getList(); 
    return response;
};

   const { isPending, error, data: countrydata } = useQuery({
    queryKey: ['countryData'],
    queryFn:  fetchCountryData,
  })





  if (isPending) return <div>Loading...</div>;
if (error) return <div>Error: {error.message}</div>;


  const overlays = {
  AUSTRALIA: "rgba(240, 90, 70, 0.55)",
  "NEW ZEALAND": "rgba(0, 200, 200, 0.5)",
  USA: "rgba(200, 180, 60, 0.54)",
  UK: "#52127f79",
  CANADA: "#687c867c",
  JAPAN: "rgba(100, 150, 200, 0.5)" // add as needed
};
  
 const CountryCard = ({ image, overlay, title, caption, slug }) => (
  <Link 
    to={`/study-abroad/${slug}`}
    style={{ textDecoration: 'none' }}
  >
    <div
      className="position-relative rounded-5 mx-auto"
      style={{ 
        height: "clamp(200px, 40vw, 360px)", 
        width: "clamp(200px, 40vw)", 
        overflow: "hidden",
        transition: "transform 0.3s ease, box-shadow 0.3s ease"
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)";
        e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.3)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      {/* Image */}
      <img
        src={image}
        loading="lazy"
        alt={title}
        className="w-100 h-100"
        style={{ objectFit: "cover" }}
      />

      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: overlay,
        }}
      />

      {/* Text container */}
      <div
        className="position-absolute w-100 px-3 d-flex align-items-end"
        style={{ bottom: "15%", left: 0, zIndex: 2 }}
      >
        <div
          className="font-level-5 mb-0 ms-2"
          style={{ 
            color: "white",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            maxWidth: "100%",
            lineHeight: "1.2",
            wordBreak: "break-word",
            whiteSpace: "normal"
          }}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
    </div>
  </Link>
);
  if(isPending) return <div>Loading...</div>;
  if(error) return <div>Error: {error.message}</div>;
   if (!countrydata || !Array.isArray(countrydata)) {
    return <div>No country data available</div>;
  }

  return (
    <div className="main-container">
      <Container fluid className="justify-content-start" style={{marginBottom:"clamp(1rem, 16vw, 10rem)"}}>
        <Row
          className="justify-content-between"
          style={{ marginTop: "1rem", cursor: "pointer" }}
        >
          <h1
            className="lh-1 font-level-4 fw-normal text-start p-0 " style={{marginBottom:"clamp(1rem,5vw,4.2rem)"}}
            
          >
            EXPLORE WHERE YOUR GLOBAL <br className="d-none d-md-block" />
            JOURNEY CAN BEGIN
          </h1>
       

       <div className="row g-3 m-0 p-0"> 
  {countrydata?.filter((country) => country?.isIncludedInIntelligentPortal === false).map((country) => (
    <Col
      key={country.id}
      xs="12" sm="6" lg="4" xl="4"
      className="cursor-pointer"
      
    >
      <CountryCard
        image={`${imageBaseApi}${country.flagMedia?.url}`}
        overlay={overlays[country.name] || "rgba(0,0,0,0.5)"}
        title={country.name.toUpperCase()}
        slug={country.slug}
      />
    </Col>
  ))}

  {/* Special "Begin Your Journey" card */}
  <Col xs="12" sm="6" lg="4" xl="4" className="cursor-pointer">
    <div
      className="d-flex flex-column justify-content-center align-items-start rounded-5 px-5 pt-5"
      style={{
        backgroundColor: "#ff4d1d",
        height: "clamp(200px, 40vw, 360px)",
        width: "100%", // fill column width
        cursor: "pointer",
        transition: "transform 0.3s ease, box-shadow 0.3s ease"
      }}
      onClick={toggleModal}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.05)";
        e.currentTarget.style.boxShadow = "0 8px 20px rgba(255, 77, 29, 0.5)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <img 
        src={arrow} 
        alt="Arrow" 
         loading="lazy"
        style={{ height: "clamp(40px, 8vw, 60px)", marginBottom: "1rem" }}
      />
      <h1 className="font-level-5 text-start" style={{ color: "white" }}>
        BEGIN <br /> YOUR <br /> JOURNEY
      </h1>
    </div>
  </Col>
</div>
          
          <div>
            <Form modal={modalOpen} toggle={toggleModal} heading="Start Your Global Journey Today" description="Tell us a bit about yourself and we'll guide you toward the right country, university, and course." closingMessage="YOU'RE ALL SET!" closingDesc="Our team will help you explore the best global options for your study journey" Explore={true} formOrigin={4}/>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Explore;